export const siteSettings = {
  name: "TradeDXC",
  link: "https://tradedxcus.pro",
  email: "support@tradedxcus.pro",
  appLink: "https://app.tradedxcus.pro",
};
